var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.searchView,
              expression: "searchView"
            }
          ]
        },
        [
          !_vm.currentPosition
            ? _c(
                "v-autocomplete",
                {
                  attrs: {
                    label: _vm.label,
                    loading: _vm.loading,
                    items: _vm.locations,
                    "search-input": _vm.search,
                    "item-text": "description",
                    filter: _vm.filterFunc,
                    placeholder: _vm.showPlaceHolder
                      ? "Search, or click on the map..."
                      : null,
                    "return-object": "",
                    "hide-no-data": "",
                    clearable: "",
                    "append-icon": ""
                  },
                  on: {
                    "update:searchInput": function($event) {
                      _vm.search = $event
                    },
                    "update:search-input": function($event) {
                      _vm.search = $event
                    },
                    input: _vm.valueChange
                  },
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                },
                [
                  _vm.currentLocationBtn
                    ? _c(
                        "v-icon",
                        {
                          attrs: { slot: "append-outer" },
                          on: { click: _vm.setCurrentPosition },
                          slot: "append-outer"
                        },
                        [_vm._v("gps_fixed")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enableCoordinates
                    ? _c(
                        "v-icon",
                        {
                          attrs: { slot: "append-outer" },
                          on: {
                            click: function($event) {
                              _vm.searchView = false
                            }
                          },
                          slot: "append-outer"
                        },
                        [_vm._v("place")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentPosition
            ? _c(
                "v-text-field",
                {
                  attrs: { label: _vm.label, readonly: "", "append-icon": "" },
                  model: {
                    value: _vm.currentPositionLabel,
                    callback: function($$v) {
                      _vm.currentPositionLabel = $$v
                    },
                    expression: "currentPositionLabel"
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: { slot: "append-outer" },
                      on: { click: _vm.resetCurrentPosition },
                      slot: "append-outer"
                    },
                    [_vm._v("clear")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.enableCoordinates
        ? _c(
            "v-layout",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.searchView,
                  expression: "!searchView"
                }
              ]
            },
            [
              _c(
                "v-flex",
                [
                  _c("v-text-field", {
                    attrs: { type: "number", label: "Latitude" },
                    on: { input: _vm.searchLocation },
                    model: {
                      value: _vm.lat,
                      callback: function($$v) {
                        _vm.lat = _vm._n($$v)
                      },
                      expression: "lat"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "ml-3" },
                [
                  _c(
                    "v-text-field",
                    {
                      attrs: { type: "number", label: "Longitude" },
                      on: { input: _vm.searchLocation },
                      model: {
                        value: _vm.lng,
                        callback: function($$v) {
                          _vm.lng = _vm._n($$v)
                        },
                        expression: "lng"
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: { slot: "append-outer" },
                          on: {
                            click: function($event) {
                              _vm.searchView = true
                            }
                          },
                          slot: "append-outer"
                        },
                        [_vm._v("search")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c612688", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c612688","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressSearch.vue
// module id = null
// module chunks = 